export class Notification {
  public id: number;
  public sticky: boolean;

  public constructor(public type: string = '', public title: string = '', public message: string = '') {
    this.id = Math.floor(Math.random() * 101);
  }
}
